$(() => {
  const key = 'set-value-on-load';
  $(`[data-${key}]`).each(function () {
    this.value = $(this).data(key);
  });
});
